var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnpinned(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.61,15.24a1.75,1.75,0,0,0,.16-.27,5.9,5.9,0,0,0,.42-3.92l2.5-2.5.51.19.61.23.45-.46L20.82,8l.71-.7-.71-.71L17.46,3.18l-.71-.71-.7.71-.56.56L15,4.19l.23.61.19.51L13,7.81A5.91,5.91,0,0,0,9,8.24a1.65,1.65,0,0,0-.25.15l-1,.68.84.84,2,2L5.71,16.88,5,19l2.12-.71,5-4.95,2,2,.84.84Zm-3-2.75-1.12-1.12L9.34,9.2l.13-.07a4.56,4.56,0,0,1,3.58-.2h.21l3.36-3.37-.43-1.12.56-.56,3.37,3.37-.56.56-1.12-.43-3.37,3.36V11a4.56,4.56,0,0,1-.2,3.58.83.83,0,0,1-.07.13Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpinned);
export default __webpack_public_path__ + "static/media/unpinned.fe190e2557bacf438d364689584e5cf7.svg";
export { ForwardRef as ReactComponent };